import { WorkType } from '@/types/jobs';
import cx from 'classnames';
import React from 'react';

import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';

import styles from './WorkTypeButtonGroup.module.scss';

type WorkTypeButton = WorkType | 'All';

interface WorkTypeButtonGroupProps {
  selectedWorkType?: WorkType;
  onWorkTypeChange: (workType?: WorkType) => void;
  className?: string;
}

interface WorktypeButtonProps {
  variant: 'contained' | 'outlined';
  color: 'primary' | 'default';
  className?: string;
  'aria-current'?: boolean;
}

const WorkTypeButtonGroup = ({
  selectedWorkType,
  onWorkTypeChange,
  className,
}: WorkTypeButtonGroupProps) => {
  const workTypeButtons: WorkTypeButton[] = ['All', 'Locum', 'Permanent'];

  const getWorkTypeButtonProps = (buttonLabel): WorktypeButtonProps =>
    selectedWorkType === buttonLabel || (!selectedWorkType && buttonLabel === 'All')
      ? {
          variant: 'contained',
          color: 'primary',
          className: cx(styles.workTypeButton, styles['workTypeButton--active']),
          'aria-current': true,
        }
      : {
          variant: 'outlined',
          color: 'default',
          className: styles.workTypeButton,
        };

  const handleWorkTypeChange = (buttonLabel: WorkTypeButton) => () => {
    onWorkTypeChange(buttonLabel === 'All' ? undefined : buttonLabel);
  };

  return (
    <ButtonGroup
      id="workTypeButtonGroup"
      data-testid="job-search-work-type-button-group"
      disableElevation
      className={cx(styles.container, className)}
      aria-label="Work type"
      fullWidth
    >
      {workTypeButtons.map(buttonLabel => (
        <Button
          key={buttonLabel}
          {...getWorkTypeButtonProps(buttonLabel)}
          onClick={handleWorkTypeChange(buttonLabel)}
          data-testid={`job-search-work-type-${buttonLabel}-button`}
        >
          {buttonLabel.toUpperCase()}
        </Button>
      ))}
    </ButtonGroup>
  );
};

export default WorkTypeButtonGroup;
